import fetch from './fetch';

const fetchLoggerList = params => fetch({ url: '/behavior_log', params });
const fetchLoggerPost = params => fetch({ url: '/behavior_log', params, methold: 'post' });
const fetchLoggerModule = params => fetch({ url: '/behavior_log_model', params });
const fetchLoggerEvent = params => fetch({ url: '/behavior_log_event', params });
export default {
  fetchLoggerList,
  fetchLoggerModule,
  fetchLoggerEvent,
  fetchLoggerPost
};
